import { createSlice } from "@reduxjs/toolkit";
import * as api from "../api/index.js";

const initialState = {
  responseError: false,
  userClaims: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthError: (state) => {
      state.responseError = true;
    },
    clearAuthError: (state) => {
      state.responseError = false;
    },
    setUserClaims: (state, action) => {
      state.userClaims = action.payload;
    },
    clearUserClaims: (state) => {
      state.userClaims = null;
    },
  },
});

export const { setAuthError, clearAuthError, setUserClaims, clearUserClaims } = authSlice.actions;

// Async thunk for fetching user claims from OIDC
export const getUserClaims = () => async (dispatch) => {
  try {
    const response = await api.getUserClaims();
    localStorage.setItem("url", response.data.APIURL);
    dispatch(setUserClaims(response.data));
  } catch (error) {
    // Error handled by axios interceptor
    console.error("Failed to fetch user claims:", error);
  }
};

export const authReducer = authSlice.reducer;
